<template>
	<div class="content-wrapper p-4">
		<div v-if="preEventExists">
			<app-overlay-loader />
		</div>
		<div class="col-12 mb-primary" v-else-if="eventExists">
			<div class="card card-with-shadow border-0 h-100">
				<!-- Banner -->
				<div
					class="banner"
					:style="{
						'background-image':
							'url(' +
							urlGenerator(
								'images/event-registration-banner.png'
							) +
							')',
					}"
				>
					<!-- Text or other content for the banner -->
				</div>
				<div class="card-header p-primary bg-transparent text-center">
					<h5 class="card-title m-0 mb-3 font-weight-bold">
						{{ $t("event_registration") }}
					</h5>
					<p class="card-text m-0">
						Thank you for your interest in our Mid-Autumn Festival
						event. Please fill in the form below and click submit to
						confirm your booking.
					</p>
				</div>
				<app-overlay-loader v-if="preloader" />
				<div class="card-body">
					<form
						ref="form"
						data-url="events"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<!-- Parent First Name -->
							<div class="col-md-6">
								<div class="form-group">
									<label
										>Parent First Name
										<span class="required-star"
											>*</span
										></label
									>
									<app-input
										type="text"
										v-model="
											eventRegistration[0]
												.parent_first_name
										"
										placeholder="Parent First Name"
										:required="true"
									/>
								</div>
							</div>
							<!-- Parent Last Name -->
							<div class="col-md-6">
								<div class="form-group">
									<label
										>Parent Last Name
										<span class="required-star"
											>*</span
										></label
									>
									<app-input
										type="text"
										v-model="
											eventRegistration[0]
												.parent_last_name
										"
										placeholder="Parent Last Name"
										:required="true"
									/>
								</div>
							</div>
							<!-- Mobile/WhatsApp Number -->
							<div class="col-md-6">
								<div class="form-group">
									<label for="inputs_mobile_number">
										Mobile/Whatsapp Number
										<span class="required-star">*</span>
									</label>
									<app-input
										id="inputs_mobile_number"
										type="tel-input"
										v-model="
											eventRegistration[0].mobile_number
										"
										placeholder="Mobile/WhatsApp Number"
										:required="true"
									/>
								</div>
							</div>
							<!-- Email Address -->
							<div class="col-md-6">
								<div class="form-group">
									<label>
										Email Address
										<span class="required-star">*</span>
									</label>
									<app-input
										type="email"
										v-model="
											eventRegistration[0].email_address
										"
										placeholder="Email Address"
										:required="true"
									/>
								</div>
							</div>
						</div>
						<div class="row">
							<!-- Country -->
							<div class="col-md-4">
								<label
									>Choose Country
									<span class="required-star">*</span></label
								>
								<app-input
									type="advance-search-select"
									:loaded-per-time="10"
									v-model="input_country"
									@input="setCountryValue"
									fetch-url="wilayah/country"
									placeholder="Choose Country"
									list-value-field="name"
									required
								/>
							</div>
							<!-- City -->
							<div class="col-md-4">
								<div class="form-group">
									<label
										>City/Suburb
										<span class="required-star"
											>*</span
										></label
									>
									<app-input
										type="advance-search-select"
										:loaded-per-time="10"
										v-model="input_city"
										@input="setCityValue"
										:fetch-url="`wilayah/city?country_id=${input_country.id}`"
										placeholder="City/Suburb"
										list-value-field="name"
										required
									/>
								</div>
							</div>
							<!-- Postcode -->
							<div class="col-md-4">
								<div class="form-group">
									<label
										>Postcode
										<span class="required-star"
											>*</span
										></label
									>
									<app-input
										type="advance-search-select"
										:loaded-per-time="10"
										v-model="input_postcode"
										@input="setPostCodeValue"
										:fetch-url="`wilayah/village?city_id=${input_city.id}`"
										placeholder="Choose Postcode"
										list-value-field="full_location"
										required
									/>
								</div>
							</div>
							<!-- How do you know about this event? -->
							<div class="col-md-6">
								<div
									class="form-group form row align-items-center"
								>
									<label class="col-sm-2 mb-sm-0">
										How do you know about this event?
									</label>
									<app-input
										class="col-sm-8"
										type="multi-select"
										:list="marketingChannelLists"
										:isAnimatedDropdown="true"
										placeholder="How do you know about this event?"
										v-model="
											eventRegistration[0]
												.marketing_channel
										"
									/>
								</div>
							</div>
							<div
								class="col-md-4"
								v-if="
									eventRegistration[0].marketing_channel.includes(
										14
									)
								"
							>
								<div class="form-group">
									<label></label>
									<app-input
										placeholder="Friend's Name"
										type="text"
										name="channel_name"
										v-model="
											eventRegistration[0].channel_name
										"
										required
									/>
								</div>
							</div>
							<div v-else class="col-md-6"></div>
							<!-- How many people attending? -->
							<div class="col-md-6">
								<div
									class="form-group form row align-items-center"
								>
									<label class="col-sm-4 mb-sm-0">
										How many people attending?
									</label>
									<label class="col-sm-2 mb-sm-0">
										Adult
										<span class="required-star">*</span>
									</label>
									<app-input
										class="col-sm-2"
										type="number"
										placeholder="Adult"
										v-model="
											eventRegistration[0].total_adult
										"
										:required="true"
									/>
									<label class="col-sm-2 mb-sm-0">
										Child
										<span class="required-star">*</span>
									</label>
									<app-input
										class="col-sm-2"
										type="number"
										placeholder="Child"
										v-model="
											eventRegistration[0].total_child
										"
										:required="true"
									/>
								</div>
							</div>
							<!-- Child Information Section Separator -->
							<div class="col-md-12">
								<div class="form-group">
									<div class="section-separator">
										<h5 class="font-weight-bold text-white">
											Child Information
										</h5>
									</div>
								</div>
							</div>
						</div>
						<template v-for="(child, index) in childs">
							<div
								class="row"
								v-if="childs.length > 1"
								:key="index"
							>
								<!-- separated by line -->
								<div class="col-md-12">
									<hr class="bold-hr" />
								</div>
								<div
									class="col-md-12 mb-4 mt-2 d-flex align-items-center"
								>
									<div class="col-md-2">
										<h5 class="font-weight-bold">
											Child #{{ index + 1 }}
										</h5>
									</div>
									<div class="col-md-4">
										<!-- delete button based on index -->
										<button
											type="button"
											class="btn btn-outline-danger btn-sm"
											@click="deleteChild(index)"
										>
											<i
												class="fas fa-trash"
												style="font-size: 10px"
											></i>
											Delete Child Data
										</button>
									</div>
								</div>
								<!-- separated by line -->
								<div class="col-md-12">
									<hr class="bold-hr" />
								</div>
							</div>
							<event-child-form
								:key="child.uuid"
								:followingSessionLists="followingSessionLists"
								v-model="childs[index]"
							/>
						</template>

						<div class="row">
							<!-- Add more child -->
							<div class="col-md-12">
								<button
									type="button"
									class="btn btn-outline-primary btn-sm"
									@click="addChild"
								>
									Add more child
									<i
										class="fas fa-plus"
										style="font-size: 10px"
									></i>
								</button>
							</div>
							<!-- Child Information Section Separator -->
							<div class="col-md-12 mt-2">
								<div class="form-group">
									<div class="section-separator">
										<h5 class="font-weight-bold text-white">
											End Child Information
										</h5>
									</div>
								</div>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								@click.prevent="submit"
							>
								{{ $t("submit") }}
							</button>
							<button
								type="submit"
								class="btn btn-secondary"
								@click.prevent="clear"
							>
								{{ $t("clear") }}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div style="height: 100vh" v-else-if="!eventExists">
			<app-error
				error-type="404"
				error-title="Page not found"
				error-description="The page you are looking for does not exist"
				url="/"
			>
			</app-error>
		</div>
	</div>
</template>

<script>
import { EventRegistrationFormMixin } from "./EventRegistrationFormMixin";
import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
import { urlGenerator } from "../../../Helpers/AxiosHelper";

export default {
	name: "EventRegistration",
	mixins: [EventRegistrationFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			urlGenerator,
			eventSlug: "",
			preEventExists: true,
			eventExists: false,
			followingSessionLists: [],
			eventRegistration: [
				{
					event_id: "",
					parent_first_name: "",
					parent_last_name: "",
					mobile_number: "",
					email_address: "",
					selected_country: "",
					postcode: "",
					city: "",
					marketing_channel: "",
					channel_name: "",
					total_adult: "",
					total_child: "",
					childs: [],
				},
			],
			childs: [
				{
					uuid: this.uuidv4(),
					first_name: "",
					last_name: "",
					is_clc_student: "no",
					clc_id_number: "",
					selected_country: "",
					place_of_birth: "",
					date_of_birth: "",
					// selected_school_name: "",
					school_name: "",
					// selected_school_level: "",
					school_level: "",
					event_detail_id: 1,
				},
			],
			marketingChannelLists: [],
			input_country: this.value
				? this.value.country
					? {
							id: this.value.country.id || 0,
							name: this.value.country.name || "",
							code: this.value.country.code,
							is_active: this.value.country.is_active,
					  }
					: {
							id: this.value.country?.id || 0,
							name: this.value.country?.name || "",
							code: this.value.country?.code,
							is_active: this.value.country?.is_active,
					  }
				: {
						id: this.value.country.id || 0,
						name: this.value.country.name || "",
						code: this.value.country.code,
						is_active: this.value.country.is_active,
				  },
			input_city: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			input_postcode: this.value
				? this.value
					? {
							id: this.value.id || 0,
							postal_code: this.value.postal_code || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							postal_code: this.value?.postal_code || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						postal_code: this.value.postal_code || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
		};
	},
	created() {
		this.eventRegistration[0].childs = this.childs;

		// Make an HTTP GET request to the endpoint [GET] /public/marketing-channel
		axios
			.get("/public/marketing-channel?per_page=50")
			.then((response) => {
				this.marketingChannelLists = response.data.data.map((item) => ({
					id: item.id,
					value: item.name,
				}));
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});

		// Get the URL search parameters
		const queryParams = new URLSearchParams(window.location.search);

		// Check if the 'event' parameter is present
		if (queryParams.has("event")) {
			// Get the value of the 'event' parameter
			this.eventSlug = queryParams.get("event");

			// Now you can use this.eventSlug as needed
			this.fetchData();
		} else {
			console.error('No "event" parameter found in the URL');
		}
	},
	methods: {
		async fetchData() {
			try {
				const [eventsResponse, eventDetailResponse] = await Promise.all(
					[
						axios.get(`/events`),
						axios.get(`/events/${this.eventSlug}/details`),
					]
				);

				const event = eventsResponse.data?.data.find(
					(item) => item.slug === this.eventSlug
				);

				if (event) {
					this.eventExists = true;
					this.preEventExists = false;
					this.eventRegistration[0].event_id = event.id;
					this.followingSessionLists = eventDetailResponse.data?.map(
						(item) => ({
							id: item.id,
							value: item.formattedEventDetail,
						})
					) || [
						{
							id: 1,
							value: "Tuesday, 26/09/2023 15:15 - 17:15 at CLC Permata Hijau",
						},
						{
							id: 2,
							value: "Wednesday, 27/09/2023 15:15 - 17:15 at CLC Kebon Jeruk",
						},
					];
				} else {
					this.eventExists = false;
					this.preEventExists = false;
					this.$toastr.e("Event not found");
				}
			} catch (error) {
				console.error("Error fetching data:", error);
				this.$toastr.e(error.message);
				this.eventExists = false;
				this.preEventExists = false;
			}
		},

		beforeSubmit() {
			this.preloader = true;
		},
		submit() {
			let hasValidationError = false;

			// Validation for child data
			if (this.childs.length >= 1) {
				this.childs.forEach((child) => {
					if (child.is_clc_student == "no") {
						if (
							child.first_name === "" ||
							child.last_name === "" ||
							child.place_of_birth === "" ||
							child.date_of_birth === "" ||
							child.school_name === "" ||
							child.school_level === "" ||
							child.event_detail_id === ""
						) {
							this.$toastr.e(
								"Please fill all the child's data before submit"
							);
							hasValidationError = true;
							return;
						}
					} else if (child.is_clc_student == "yes") {
						if (
							child.first_name === "" ||
							child.last_name === "" ||
							child.clc_id_number === "" ||
							child.event_detail_id === ""
						) {
							this.$toastr.e(
								"Please fill all the child's data before submit"
							);
							hasValidationError = true;
							return;
						}
					}
				});
			} else {
				// Validation for parent data
				const parent = this.eventRegistration[0];
				if (
					parent.parent_first_name === "" ||
					parent.parent_last_name === "" ||
					parent.mobile_number === "" ||
					parent.email_address === "" ||
					parent.selected_country === "" ||
					parent.postcode === "" ||
					parent.city === "" ||
					parent.marketing_channel.length === 0 ||
					parent.total_adult === "" ||
					parent.total_child === ""
				) {
					this.$toastr.e("Please fill all the data before submit");
					hasValidationError = true;
				}
			}

			// Additional validations
			if (this.eventRegistration[0].mobile_number.length < 10) {
				this.$toastr.e("Mobile number must be at least 10 digits");
				hasValidationError = true;
			}

			if (
				this.eventRegistration[0].mobile_number.substring(0, 2) !==
					"08" &&
				this.eventRegistration[0].mobile_number.substring(0, 2) !== "62"
			) {
				this.$toastr.e(
					"Mobile number must start with 08 or 62 (Indonesia)"
				);
				hasValidationError = true;
			}

			// Validate the postcode
			// if (this.eventRegistration[0].postcode.length < 5) {
			// 	this.$toastr.e("Postcode must be at least 5 digits");
			// 	hasValidationError = true;
			// }

			// Validate date of birth
			this.childs.forEach((child) => {
				const dateOfBirth = new Date(child.date_of_birth);
				const today = new Date();
				const age = today.getFullYear() - dateOfBirth.getFullYear();
				const monthDifference =
					today.getMonth() - dateOfBirth.getMonth();

				if (
					monthDifference < 0 ||
					(monthDifference === 0 &&
						today.getDate() < dateOfBirth.getDate())
				) {
					// Adjust the age calculation without modifying the constant
					const adjustedAge = age - 1;

					if (adjustedAge < 3) {
						this.$toastr.e(
							"Child's age must be at least 3 years old"
						);
						hasValidationError = true;
						return;
					}
				} else {
					if (age < 3) {
						this.$toastr.e(
							"Child's age must be at least 3 years old"
						);
						hasValidationError = true;
						return;
					}
				}
			});

			// If no validation errors occurred, call this.save()
			if (!hasValidationError) {
				this.save(this.eventRegistration);
			}
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.clear();
		},
		afterFinalResponse() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterError(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clear() {
			this.eventRegistration = [
				{
					event_id: "",
					parent_first_name: "",
					parent_last_name: "",
					mobile_number: "",
					email_address: "",
					selected_country: "",
					postcode: "",
					city: "",
					marketing_channel: "",
					channel_name: "",
					total_adult: "",
					total_child: "",
					childs: [],
				},
			];
			this.childs = [
				{
					uuid: this.uuidv4(),
					first_name: "",
					last_name: "",
					is_clc_student: "no",
					clc_id_number: "",
					selected_country: "",
					place_of_birth: "",
					date_of_birth: "",
					// selected_school_name: "",
					school_name: "",
					// selected_school_level: "",
					school_level: "",
					event_detail_id: 1,
				},
			];
			this.input_country = {
				id: undefined,
				name: "",
				code: "",
				is_active: "",
			};
			this.input_postcode = {
				id: undefined,
				code: "",
				postal_code: "",
				is_active: "",
			};
			this.input_city = {
				country_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				city: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		addChild() {
			this.childs.push({
				uuid: this.uuidv4(),
				first_name: "",
				last_name: "",
				is_clc_student: "no",
				clc_id_number: "",
				selected_country: "",
				place_of_birth: "",
				date_of_birth: "",
				school_name: "",
				school_level: "",
				event_detail_id: 1,
			});
		},
		deleteChild(index) {
			this.childs.splice(index, 1);
		},
		updateChilds() {
			this.eventRegistration[0].childs = this.childs;
		},
		uuidv4() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(
					c ^
					(crypto.getRandomValues(new Uint8Array(1))[0] &
						(15 >> (c / 4)))
				).toString(16)
			);
		},

		setCountryValue(data) {
			this.eventRegistration[0].selected_country =
				this.eventRegistration[0].selected_country;
			if (data && data.hasOwnProperty("id")) {
				this.eventRegistration[0].selected_country = data.id;
				this.resetCity();
			}
		},
		setCityValue(data) {
			this.eventRegistration[0].city = this.eventRegistration[0].city;
			if (data && data.hasOwnProperty("id")) {
				this.eventRegistration[0].city = data.id;
				this.resetPostCode();
			}
		},
		setPostCodeValue(data) {
			this.eventRegistration[0].postcode =
				this.eventRegistration[0].postcode;
			if (data && data.hasOwnProperty("id")) {
				this.eventRegistration[0].postcode = data.id;
			}
		},
		resetPostCode() {
			this.input_postcode = {
				id: undefined,
				code: "",
				postal_code: "",
				is_active: "",
			};
		},
		resetCity() {
			this.input_city = {
				country_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				city: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
	},
	watch: {
		eventRegistration: {
			handler: function (val) {
				// this.updateChilds();
				// if childs length is > 1, then update the childs
				if (this.childs.length > 1) {
					this.childs.forEach((child) => {
						child.selected_country = val[0].selected_country;
					});
				}
			},
			deep: true,
		},
		childs: {
			handler: function (val) {
				this.updateChilds();
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
/* Style for required asterisk */
.required-star {
	color: red;
}
.mt-4 {
	margin-top: 4rem !important;
}
.mt-2 {
	margin-top: 2rem !important;
}
.bold-hr {
	border-top: 2px solid #000; /* You can adjust the color and thickness as needed */
}
.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.banner {
	/* background-size: cover; Resize the background image to cover the entire container */
	/* background-size: contain; /* Resize the background image to contain the entire image within the container */
	/* background-size: 100% auto; /* 100% width and height, but constrain proportions */
	background-size: 100% 100%; /* 100% width and height, no constraint */
	background-repeat: no-repeat; /* Prevent image repetition */
	background-position: center; /* Center the image */
	height: 200px; /* Adjust height as needed */
}
.section-separator {
	background-color: #007bff; /* Choose your desired background color */
	padding: 10px 15px; /* Adjust the padding as needed */
	border-radius: 5px; /* Add rounded corners if desired */
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
}

.section-separator h5 {
	margin: 0; /* Remove any default margin for the heading */
}
</style>
